import React from 'react';

// border border-1 border-secondary
const SummaryCard = ({ title, value }) => (
    <div className="py-2 px-4 bg-white realEstateSummaryCard rounded d-flex flex-column justify-content-center align-items-center">
        <div className="fs-6 fw-bold">{title}</div>
        <div className="fs-5 fw-bold">{value}</div>
    </div>
);

export default SummaryCard;
